import React, { useState } from 'react';
import { Form, Alert } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { apiService } from '../services/api';
import logo from '../assets/logo_black.png';
import '../components/LoginForm.css';

export const ResetPasswordPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        if (!token) {
            setError('Chýba token na obnovenie hesla.');
            return;
        }

        if (password.length < 8) {
            setError('Heslo musí mať aspoň 8 znakov.');
            return;
        }

        if (password !== passwordConfirm) {
            setError('Heslá sa nezhodujú.');
            return;
        }

        setLoading(true);

        const response = await apiService.resetPassword(token, password);

        if (response.success) {
            setSuccess(true);
        } else {
            setError(response.message || 'Nastala chyba. Skúste to znova neskôr.');
        }

        setLoading(false);
    };

    if (!token) {
        return (
            <div className="page page-center">
                <div className="container container-tight py-4">
                    <div className="text-center mb-4">
                        <img src={logo} alt="Logo" style={{ height: '60px' }} />
                    </div>
                    <div className="card card-md">
                        <div className="card-body text-center">
                            <Alert variant="danger">Neplatný odkaz na obnovenie hesla.</Alert>
                            <Link to="/" className="btn btn-pill btn-primary">Späť na prihlásenie</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page page-center">
            <div className="container container-tight py-4">
                <div className="text-center mb-4">
                    <img src={logo} alt="Logo" style={{ height: '60px' }} />
                </div>

                <div className="card card-md">
                    <div className="card-body">
                        <h2 className="h2 text-center mb-4">Nové heslo</h2>

                        {error && <Alert variant="danger">{error}</Alert>}

                        {success ? (
                            <div className="text-center">
                                <Alert variant="success">Heslo bolo úspešne zmenené.</Alert>
                                <Link to="/" className="btn btn-pill btn-primary">Prihlásiť sa</Link>
                            </div>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Nové heslo</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Minimálne 8 znakov"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                        minLength={8}
                                        autoComplete="new-password"
                                        autoFocus
                                    />
                                </div>

                                <div className="mb-3">
                                    <label className="form-label">Potvrdenie hesla</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Zopakujte heslo"
                                        value={passwordConfirm}
                                        onChange={(e) => setPasswordConfirm(e.target.value)}
                                        required
                                        minLength={8}
                                        autoComplete="new-password"
                                    />
                                </div>

                                <div className="form-footer">
                                    <button type="submit" className="btn btn-pill btn-primary w-100" disabled={loading}>
                                        {loading ? 'Ukladám...' : 'Zmeniť heslo'}
                                    </button>
                                </div>
                            </Form>
                        )}
                    </div>
                </div>

                <div className="text-center text-secondary mt-3">
                    <Link to="/">Späť na prihlásenie</Link>
                </div>
            </div>
        </div>
    );
};